import { render, staticRenderFns } from "./CompanyTaxOptionModal.vue?vue&type=template&id=28617208&scoped=true&"
import script from "./CompanyTaxOptionModal.vue?vue&type=script&lang=js&"
export * from "./CompanyTaxOptionModal.vue?vue&type=script&lang=js&"
import style0 from "./CompanyTaxOptionModal.vue?vue&type=style&index=0&id=28617208&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "28617208",
  null
  
)

export default component.exports